export default __webpack_public_path__ + "static/media/logo1.bcc91a84.png";